import { FgdsProductType } from "@domain/product/product";
import { Expose, Type } from "class-transformer";
import { ArrayMinSize, IsArray, IsEnum, IsInt, IsOptional, IsString, IsUUID, Min, ValidateNested } from "class-validator";
import { v4 as uuidv4 } from "uuid";

export class FgdsDirectBomLine {
  @IsString()
  public partNumber: string;

  @IsString()
  public name: string;

  @IsEnum(FgdsProductType)
  public productType: FgdsProductType;

  @IsInt()
  @Min(1)
  public quantity: number;

  constructor(partNumber: string, name: string, productType: FgdsProductType, quantity: number) {
    this.partNumber = partNumber;
    this.name = name;
    this.productType = productType;
    this.quantity = quantity;
  }

  static create(partNumber: string, name: string, productType: FgdsProductType, quantity = 1): FgdsDirectBomLine {
    return new FgdsDirectBomLine(partNumber, name, productType, quantity);
  }
}

export class FgdsDirectBomEntry {
  @IsUUID()
  public readonly id: string;

  @IsString()
  public name: string;

  @IsEnum(FgdsProductType)
  public productType: FgdsProductType;

  @IsInt()
  @Min(0)
  public quantity: number;

  @IsString()
  @IsOptional()
  public positionNumber?: string;

  @IsArray()
  @ArrayMinSize(1)
  @ValidateNested({ each: true })
  @Type(() => FgdsDirectBomLine)
  @Expose({ name: "lines" })
  public lines: FgdsDirectBomLine[];

  constructor(
    id: string,
    name: string,
    productType: FgdsProductType,
    quantity: number,
    lines: FgdsDirectBomLine[],
    positionNumber?: string,
  ) {
    this.id = id;
    this.name = name;
    this.productType = productType;
    this.quantity = quantity;
    this.lines = lines;
    this.positionNumber = positionNumber;
  }

  static create(name: string, productType: FgdsProductType, quantity: number, lines: FgdsDirectBomLine[]): FgdsDirectBomEntry {
    return new FgdsDirectBomEntry(uuidv4(), name, productType, quantity, lines);
  }

  get mainProductId(): string | undefined {
    return this.lines[0]?.partNumber;
  }
}
